<template>
    <div>
        <v-dialog
            v-model="display"
            v-if="display"
            width="750"
            persistent
            scrollable>
            <v-card>
                <v-card-title>
                    {{ title }}
                    <v-spacer></v-spacer>
                    <v-switch v-model="form.is_taxable" :label="$t('taxable')" dense></v-switch>
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-row>
                            <v-col>
                                <v-autocomplete
                                    dense
                                    hide-details="auto"
                                    v-model="form.item_id"
                                    :rules="rules.item"
                                    :label="$t('item')"
                                    item-text="name"
                                    item-value="id"
                                    :items="items"
                                    >
                                </v-autocomplete>
                            </v-col>
                            <v-col>
                                <v-select
                                    dense
                                    hide-details="auto"
                                    v-model="form.cast_type_id"
                                    :rules="rules.cast_type_id"
                                    :loading="loading.castTypes"
                                    :disabled="loading.castTypes"
                                    :label="$t('cast_type_title')"
                                    :items="castTypes"
                                    item-text="name"
                                    item-value="id">
                                </v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    dense
                                    hide-details="auto"
                                    label="Measure Unit"
                                    :rules="rules.measure_unit_id"
                                    v-model="form.measure_unit_id"
                                    item-text="name"
                                    item-value="id"
                                    :items="item ? item.measure_units : []"
                                    >
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    dense
                                    hide-details="auto"
                                    v-model="form.quantity"
                                    :rules="rules.quantity"
                                    :label="$t('quantity')">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    dense
                                    hide-details="auto"
                                    v-model="form.price"
                                    :prefix="currency"
                                    :rules="rules.price"
                                    :label="$t('price')">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    dense
                                    hide-details="auto"
                                    :label="$t('discount')"
                                    v-model="form.discount"
                                    :rules="rules.discount"
                                    :prefix="currency">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    dense
                                    readonly
                                    hide-details="auto"
                                    :value="subtotalF"
                                    :prefix="currency"
                                    :label="$t('sub_total')">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    readonly
                                    dense
                                    hide-details="auto"
                                    :label="$t('tax_percentage')"
                                    :prefix="currency"
                                    :value="taxF">
                                </v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field
                                    readonly
                                    dense
                                    hide-details="auto"
                                    :label="$t('total')"
                                    :prefix="currency"
                                    :value="totalF">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="submit"
                        text>
                        {{ $t("add_btn") }}
                    </v-btn>
                    <v-btn
                        @click="close"
                        text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ItemSearchDialog
            @store="setItem"
            ref="itemSearchDialog"/>
    </div>
</template>

<script>
import { formatNumber } from 'accounting';
import { toNumber } from 'lodash';
// import ItemSearchDialog from '../warehouse/ItemSearchDialog';
import { mapActions, mapGetters, mapState } from 'vuex';
import { clone, isEmpty } from 'lodash';

export default {
    name: "InvoiceItemLineDialog",
    components: {
        // ItemSearchDialog
    },
    props: {
        editMode: {
            type: Boolean,
            required: true
        },
        display: {
            type: Boolean,
            required: true
        },
        line: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            currencySymbol: "SDG",
            taxPercentage: 17,
            displayed: false,
            valid: false,
            form: {
                id: null,
                row_id: null,
                sales_order_item_id: null,
                item: null,
                item_id: null,
                cast_type: null,
                cast_type_id: null,
                measure_unit: null,
                measure_unit_id: null,
                quantity: 0,
                price: 0,
                discount: 0,
                is_taxable: false
            },
            numericsKeys: ['quantity', 'price', 'tax', 'disconut'],
            rules: {
                item: [
                    v => !!v || this.$t('rules_required')
                ],
                cast_type_id: [
                    v => !!v || this.$t('rules_required')
                ],
                quantity: [
                    v => !!v || this.$t('rules_required')
                ],
                price : [
                    v => !!v || this.$t('rules_required')
                ],
                // taxPercentage : [
                //     v => v < 100 || this.$t('invalid_percentage'),
                //     v => v >= 0 || this.$t('invalid_percentage')
                // ],
                discount : [
                    // v => !!v || this.$t('rules_required')
                ],
                measure_unit_id: [
                    v => !!v || this.$t('rules_required')
                ]
            },
            loading: {
                castTypes: false,
                itemMeasureUnits: false
            }
        }
    },
    computed: {
        ...mapState('sales/castType', ["castTypes"]),
        ...mapState("warehouse/itemMeasureUnit", ["itemMeasureUnits"]),
        ...mapGetters({
           items: "sales/item/items" 
        }),
        title() {
            if(this.notEditMode) return this.$t('new_item_line')
            else return this.$t('edit_item_line')
        },
        notEditMode() {
            return !this.editMode;
        },
        total() {
            return parseFloat(this.subtotal + this.tax);
        },
        totalF() {
            return formatNumber(this.total, 2);
        },
        subtotal() {
            return parseFloat(this.form.quantity) * parseFloat(this.form.price) - parseFloat(this.form.discount);
        },
        subtotalF() {
            return formatNumber(this.subtotal, 2);
        },
        currency() {
            return this.currencySymbol;
        },
        tax() {
            if(this.form.is_taxable === true) return parseFloat(this.taxPercentage/100) * parseFloat(this.subtotal);
            else return parseFloat(0);
        },
        taxF() {
            return formatNumber(this.tax, 2);
        },
        discount() {
            return toNumber(this.form.discount);
        },
        discountF() {
            return formatNumber(this.discount, 2);
        },
        hasItem() {
            return !!this.form.item_id;
        },
        hasNoItem() {
            return !this.hasItem;
        },
        measureUnitIsLoading() {
            return this.loading.itemMeasureUnits;
        },
        measureUnitIsDisabled() {
            return this.loading.itemMeasureUnits || this.hasNoItem;
        },
        hasLineProp() {
            return !this.hasNoLineProp;
        },
        hasNoLineProp() {
            return isEmpty(this.line);
        },
        readyLine() {
            return {
                id: this.form.id,
                row_id: this.form.row_id,
                item: this.item.name,
                item_id: this.form.item_id,
                cast_type: this.form.cast_type,
                cast_type_id: this.form.cast_type_id,
                measure_unit_id: this.form.measure_unit_id,
                measure_unit: this.item.measure_units.find(item => item.id == this.form.measure_unit_id).abbreviation,
                quantity: parseFloat(this.form.quantity),
                price: parseFloat(this.form.price),
                subtotal: this.subtotal,
                // subtotalF: this.subtotalF,
                tax: this.tax,
                // taxF: this.taxF,
                discount: parseFloat(this.discount),
                // discountF: this.discountF,
                total: this.total,
                // totalF: this.totalF,
                is_taxable: this.form.is_taxable
            }
        },
        item() {
            if(!this.form.item_id) return {};
            return this.items.find(item => item.id == this.form.item_id);
        }
    },
    methods: {
        ...mapActions("sales/castType", ["fetchCastTypes"]),
        ...mapActions("warehouse/itemMeasureUnit", ["fetchItemMeasureUnits", "clearItemMeasureUnits"]),
        close() {
            this.$emit("close");
        },
        submit() {
            this.setCastType();
            // this.setMeasureUnit();
            this.$emit("submit", this.readyLine);
        },
        openItemSearchDialog() {
            this.$refs.itemSearchDialog.open(this.form.item);
        },
        clearItem() {
            this.form.item = null;
            this.form.item_id = null;
            this.clearItemMeasureUnits();
        },
        setItem(params) {
            this.form.item = params.name;
            this.form.item_id = params.id;
            this.getItemMeasureUnit();
        },
        getCastTypes() {
            if(this.castTypes.length) return;
            this.loading.castTypes = true;
            this.fetchCastTypes().then(() => this.loading.castTypes = false).catch(() => this.fetchCastTypes())
        },
        /**
         * Sets the cast type from the cast_type_id by finding the relivant record in the array.
         */
        setCastType() {
            this.form.cast_type = this.castTypes.find(each => each.id == this.form.cast_type_id).name;
        },
        setMeasureUnit() {
            this.form.measure_unit = this.itemMeasureUnits.find(each => each.measure_unit_id == this.form.measure_unit_id).abbreviation;
        },
        setFormFromLineProps() {
            console.log(this.line);
            this.form = clone(this.line, true);
        }
    },
    created() {
        this.getCastTypes();
        if(this.hasLineProp) this.setFormFromLineProps();
        // if(this.hasLineProp && this.editMode) this.setTaxPercentage();
        // if(this.hasNoLineProp) this.setDefaultTaxPercentage();
    }
}
</script>

